













import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";
import ContentFeedCover from "@/components/ContentFeedCover";

export default defineComponent({
  name: "MessageItemContentFeedView",
  components: { BaseImage, ContentFeedCover, BaseSpinner },
  props: {
    id: { type: String, required: true },
    opponent: { type: Boolean, required: true },
  },
  setup(props) {
    const contentSet = ref<ContentSet | null>(null);
    const loading = ref(true);

    const to = computed(() => {
      if (!contentSet.value) return undefined;
      return getProfileUrl(contentSet.value.userId, { feedId: contentSet.value.id });
    });

    const getContentSet = async () => {
      try {
        loading.value = true;
        providers.ContentSetProvider.setReceiveErrors(false);
        contentSet.value = await providers.ContentSetProvider.findById({ id: props.id });
      } catch (e) {
        contentSet.value = null;
      } finally {
        loading.value = false;
      }
    };
    getContentSet();

    return { loading, contentSet, to };
  },
});
